import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/fbProject'

export const fbProjectService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search
};

function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data, showAlert: false })
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data});
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data});
}

function deleteItem(id, db) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${db}`, 'DELETE', { })
}

//show
function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', {})
}